import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { ScaffoldTimelineQuery } from '../model/query/scaffold-timeline-query';
import { DiaryQuery } from '../model/query/diary-query';
import { ScaffoldDetailQuery } from '../model/query/scaffold-detail-query';
import { ScaffoldStatisticsQuery } from '../model/query/scaffold-statistics-query';
import { ActivitiesQuery } from '../model/query/activities-query';
import { ActivityDetailQuery } from '../model/query/activity-detail-query';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the Scaffold API endpoint.
@Injectable()
export class ScaffoldEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  ScaffoldTimelineQuery(queryData: ScaffoldTimelineQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.ScaffoldTimeline.ScaffoldTimelineQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  DiaryQuery(queryData: DiaryQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.DiaryQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  ScaffoldDetailQuery(queryData: ScaffoldDetailQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.ScaffoldDetailQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  ScaffoldStatisticsQuery(queryData: ScaffoldStatisticsQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.ScaffoldStatisticsQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  ActivitiesQuery(queryData: ActivitiesQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.Activities.ActivitiesQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  ActivityDetailQuery(queryData: ActivityDetailQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.Activities.ActivityDetailQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  Sync(ifModifiedSince: string, isInitialLoad: boolean): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Scaffold?ifModifiedSince=' + ifModifiedSince + '&isInitialLoad=' + isInitialLoad,
      options);
  }

  GetSingle(scaffoldId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Scaffold/' + scaffoldId,
      options);
  }
}
